import { Injectable } from '@angular/core';
import { RequestService } from './requestService.service';
import * as moment from 'moment';
import { BusinessConfigurationMessages, ServiceOrderStatus } from './enumerations.class';
import { CacheVisit } from './entities/cacheVisit.class';
import { MobileService } from './mobileLogin-api.service';
import { CacheAssignedPatient } from './entities/cacheAssignedPatient.class';
import { DateFormat, DateTimeFormat, MomentDefaultFormat } from './entities/constantsExport.class';
import { CacheCoordinates } from './entities/cacheCoordinates.class';
import { AvailableShift } from './entities/availableShift.class';
import { NetworkService } from './networkService.service';
import { MomentFormats } from 'src/shared/entities/momentFormats.class';

@Injectable()
export class BusinessService {

    public notificationCenterData: any[] = [];
    public notificationCount: any = 0;
    public notificationCenterMessages: any[] = [];
    public notificationCenterHr: any[] = [];
    public shiftsCount: any = 0;

    public readonly HOUR_FORMAT = "h:mm A";

    constructor(
        private requestService: RequestService,
        private mobileService: MobileService
    ) {

    }


    checkForPreferredWorker(currentCase) {
        //  return currentCase.preferredWorker == this.requestService.workerData.MemberId && currentCase.visitStatus == ServiceOrderStatus.Assigned;
    }

    getColorByAssignedStatus(visit: CacheVisit, isFromAssignedCases = false) {
        switch (visit.MemberId) {
            case 0:
                {
                    return "assigndetailscontainer-unassigned";
                }
            default:
                {
                    if (visit.Status == ServiceOrderStatus.Pending || visit.Status == ServiceOrderStatus.Assigned) {
                        return "assigndetailscontainer-unassigned";
                    }
                    else {

                        if (isFromAssignedCases && visit.Status != ServiceOrderStatus.Assigned && visit.Status != ServiceOrderStatus.Pending) {
                            return "assigndetailscontainer-assigned disabled";
                        }
                        else {
                            return "assigndetailscontainer-assigned";
                        }
                    }
                }
        }
    }

    getColorByStatus(visit: CacheVisit) {
        switch (visit.Status) {
            case ServiceOrderStatus.Assigned:
                {
                    return "assignstatus assigned";
                }
            case ServiceOrderStatus.Scheduled:
                {
                    return "assignstatus scheduled";
                }
            case ServiceOrderStatus.Arrived:
                {
                    return "assignstatus arrived";
                }
            case ServiceOrderStatus.Closed:
                {
                    return "assignstatus closed";
                }
            case ServiceOrderStatus.Unassigned:
                {
                    return "assignstatus unassigned";
                }
            case ServiceOrderStatus.Pending:
                {
                    return "assignstatus pending"
                }
            default:
                {
                    return "assignstatus";
                }
        }
    }

    checkAvailableForReturn(currentCase) {
        // return currentCase.isAvailableForReturn && (currentCase.visitStatus == ServiceOrderStatus.Arrived || currentCase.visitStatus == ServiceOrderStatus.Scheduled);
    }

    updateNotificationCenterCount() {
        return new Promise<any>(resolve => {
            this.requestService.getVisitsForNotificationCenter().then(data => {

                this.notificationCenterData = data;

                this.requestService.getUserMessagesForNotificationCenter().then(data => {
                    this.notificationCenterMessages = data;

                    this.requestService.getExpiringHrRequirementsForNotificationCenter().then(data => {
                        this.notificationCenterHr = data;

                        var notificationCount = this.notificationCenterData.length + this.notificationCenterHr.length + this.notificationCenterMessages.length;

                        if (notificationCount > 0) {
                            this.notificationCount = notificationCount;
                        }

                        resolve([]);
                    });
                });
            });
        });
    }
    updateAvailableShiftsCount() {
        return new Promise<any>(resolve => {
            this.requestService.getWorkerAvailableShifts().then(visits => {
                var counter = visits.length;
                if (counter > 0) {
                    this.shiftsCount = counter;
                }

                resolve([]);
            });
        });
    }

    checkIfAvailableForArrival(visit: CacheVisit) {
        var pastDays = +this.mobileService.getConfigurationValue(BusinessConfigurationMessages.DisplayVisitsFromXPastDays)
        if( pastDays> 0)
        {
            return visit.Status == ServiceOrderStatus.Scheduled && 
            ((moment().isSame(moment(visit.AppointmentDate, MomentFormats.momentFormats), "day") 
            || moment(visit.AppointmentDate, MomentFormats.momentFormats) >=  moment(visit.AppointmentDate, MomentFormats.momentFormats).add(-pastDays,'d'))
            && moment(visit.AppointmentDate, MomentFormats.momentFormats) <= moment().add(1, "day"));
        }
        else
        {
            return visit.Status == ServiceOrderStatus.Scheduled && moment().isSame(moment(visit.AppointmentDate, MomentFormats.momentFormats), "day");
        }
    }


    getCookie(name: string, decode: boolean) {
        const value = "; " + document.cookie;
        const parts = value.split("; " + name + "=");

        if (parts.length == 2) {
            var cookie = parts.pop().split(";").shift();
            if (decode) {
                return atob(cookie);
            }

            return cookie;
        }

        return "";
    }

    setCookie(name: string, val: string) {
        const date = new Date();
        let value = btoa(val);
        // Set it expire in 300 days
        date.setTime(date.getTime() + (300 * 24 * 60 * 60 * 1000));

        // Set it
        document.cookie = name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
    }

    checkShowUploadTimesheets(visit: CacheVisit) {
        var showVisitUploadDocs = this.mobileService.hasPermission(BusinessConfigurationMessages.MobileShowVisitUploadDocsButton);
        return (moment(visit.AppointmentDate, MomentFormats.momentFormats).isBefore(moment(), "day") && showVisitUploadDocs);
    }

    checkIfSameDay(visit: CacheVisit) {
        return moment(visit.AppointmentDate, MomentFormats.momentFormats).isSame(moment(), "day");
    }

    checkIfSameDay2(appointmentDate) {
        return moment(appointmentDate, MomentFormats.momentFormats).isSame(moment(), "day");
    }

    getPatientFullName(entity: CacheVisit | CacheAssignedPatient, isOpenShift: boolean) {
        var ShowOnlyFirstNameLastInitialCityForOpenShifts = this.mobileService.hasPermission(BusinessConfigurationMessages.ShowOnlyFirstNameLastInitialCityForOpenShifts);
        if(entity){
            if(isOpenShift && ShowOnlyFirstNameLastInitialCityForOpenShifts){
            return `${entity.PatientFirstName} ${entity.PatientLastName.charAt(0)}`;
            }
            else{
            return `${entity.PatientFirstName} ${entity.PatientLastName}`;
            }
        }else{
            return ``;
        }
    }

    getWorkerFullName(visit: CacheVisit) {
        return `${visit.WorkerFirstName} ${visit.WorkerLastName}`;
    }

    getVisitTimeInterval(visit: CacheVisit) {
        if(visit){
            if(visit.Status < ServiceOrderStatus.Arrived || visit.Status ==  ServiceOrderStatus.Unassigned)
            {
                if(visit.RelevantInformation == 1){
                    var response = visit.Duration / 60 > 0 ? (Math.floor(visit.Duration / 60)).toString() + "h " : "";
                    response += visit.Duration % 60 > 0 ? (visit.Duration % 60).toString() + "m" : "";
                    return response;
                }
                var visitEnd = this.getVisitAppointmentEndTime(visit);
                return `${moment(visit.AppointmentDate, MomentFormats.momentFormats).format(this.HOUR_FORMAT)} - ${visitEnd.format(this.HOUR_FORMAT)}`;
            }
            else
            {
                var visitEnd2 = visit.Status == ServiceOrderStatus.Departure ? moment(visit.DepartureTime, MomentFormats.momentFormats) : this.getVisitArrivalEndTime(visit);
                return `${moment(visit.ArrivalTime, MomentFormats.momentFormats).format(this.HOUR_FORMAT)} - ${visitEnd2.format(this.HOUR_FORMAT)}`;
            }
        }else{
            return ``;
        }
    }

    getVisitAppointmentEndTime(visit: CacheVisit) {
        return moment(visit.AppointmentDate, MomentFormats.momentFormats).add(visit.Duration, "minutes");
    }

    getVisitArrivalEndTime(visit: CacheVisit) {
        return moment(visit.ArrivalTime, MomentFormats.momentFormats).add(visit.Duration, "minutes");
    }

    getVisitFullAddress(visit: CacheVisit, isOpenShift:boolean) {
        var ShowOnlyFirstNameLastInitialCityForOpenShifts = this.mobileService.hasPermission(BusinessConfigurationMessages.ShowOnlyFirstNameLastInitialCityForOpenShifts);
        if(isOpenShift && ShowOnlyFirstNameLastInitialCityForOpenShifts){
            return `${visit.City}`;
        }
        else{
        return `${visit.Address1}, ${visit.City}, ${visit.PostalCode}`;
        }
    }

    getAssignedPatientBadge(visit: AvailableShift){
        var badge = "";
        if(visit.IsAssignedPatient){
            badge = "Assigned Caregiver"
        }
        return badge;
    }

    shouldDepart(visit: CacheVisit) {
        return new Promise<any>(resolve =>{
            if(visit.IsCreatedByPhone){
                resolve({"shouldDepart": true, "responseMessage": ""})
            }

            var scheduledDeparture = moment(visit.ArrivalTime, MomentFormats.momentFormats).add(visit.Duration, "minutes");

            if(visit.Status == ServiceOrderStatus.Scheduled)
            {
                scheduledDeparture = moment().add(visit.Duration, "minutes");
            }

            if (moment() > scheduledDeparture) {
                resolve({"shouldDepart": true, "responseMessage": ""})
            }
    
            var timeToWait = scheduledDeparture.diff(moment(), "minutes");
    
            var timeToWaitHours = "";
            var timeToWaitMinutes = "";
    
            timeToWaitHours = `${Math.floor(timeToWait / 60)}h`;
            timeToWaitMinutes = `${timeToWait % 60}m`;
    
            var responseMessage = `Your expected departure time is  ${scheduledDeparture.format("hh:mm A")}. If you would like to complete your fully scheduled time, please clock out in ${timeToWaitHours} ${timeToWaitMinutes}.`
    
            resolve({"shouldDepart": false, "responseMessage": responseMessage});
        });


    }

    getTimeDifference(start, end, granularity)
    {
        return moment(end, MomentFormats.momentFormats).diff(moment(start, MomentFormats.momentFormats), granularity);
    }

    checkGpsCoordinates(visit: CacheVisit, location: CacheCoordinates, isArrival)
    {
        try
        {
            if(visit.DisregardLocationWarnings)
            {
                return true;
            }

            var acceptOnlyInconfiguredRange = this.mobileService.hasPermission(BusinessConfigurationMessages.ReportArrivalDepartureOnlyIfGPSWithinRange);
            
            if(!acceptOnlyInconfiguredRange)
            {
                return true;
            }

            if(this.coordinatesAreRefused(location.Latitude, location.Longitude))
            {
                return false;
            }

            if(this.coordinatesAreRefused(visit.Latitude, visit.Longitude))
            {
                return true;
            }

            var distance = this.calculateDistanceHarvesine(visit.Latitude, visit.Longitude, location.Latitude, location.Longitude);
            var distanceLimit = this.getMaxDistanceFromVisit(isArrival);

            if(distance <= distanceLimit)
            {
                return true;
            }

            for(var addr of visit.PatientAddressList)
            {
                if(addr.Latitude == 0 && addr.Longitude == 0)
                {
                    continue;
                }
               
                distance = this.calculateDistanceHarvesine(addr.Latitude, addr.Longitude, location.Latitude, location.Longitude);
               
                if(distance <= distanceLimit)
                {
                    return true;
                }
            }

            return false;
        }
        catch
        {

            return false;
        }
    }

    private coordinatesAreRefused(latitude, longitude){
        if((latitude == 0 && longitude == 0) ||
            (latitude == -1 && longitude == -1)) {
            return true;
        }
        else{
            return false;
        }
    }

    calculateDistanceHarvesine(lat1, long1, lat2, long2)
    {
        let R = 3956 // miles;
        let dLat = (lat2 - lat1) * (Math.PI / 180);
        let dLon = (long2 - long1) * (Math.PI / 180);
        lat1 = lat1 * (Math.PI / 180);
        lat2 = lat2 * (Math.PI / 180);
        let a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
                Math.cos(lat1) * Math.cos(lat2) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
        let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        let d = R * c;

        return d;
    }

    getDurationInHoursMinutes(duration: number)
    {
        var hours = Math.floor(duration / 60);
        var minutes = duration % 60;

        return `${hours}h ${minutes}m`;
    }

    private getMaxDistanceFromVisit(isArrival)
    {
        var config = isArrival ? "Mobile - Non arrival GPS location > _ miles difference": "Mobile - Non departure GPS location > _ miles difference";

        var maxDistance = +this.mobileService.getConfigurationValue(config);
        
        if(isNaN(maxDistance))
        {
            return 0;
        }

        return maxDistance;
    }

}